import { Container, delayedCall, dispatcher, ingenuity, IObject, killDelayedCall, SpineBase } from "@quest/base-core";
import { HoldAndRespinModel } from "../Model/HoldAndRespinModel";
import { HoldAndRespinView } from "../View/HoldAndRespinView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotConstantsBehavior";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotEventDispatchersBehavior";

export class BigFishController {
    private soundName: any
    private readonly view: HoldAndRespinView;
    protected model: HoldAndRespinModel;
    private bigFishOnReelsContainer: Container;

    private  readonly sizeToDimention: any = {
        4: [2, 2], 6: [2, 3], 9: [3, 3], 12: [3, 4], 16: [4, 4], 20: [4, 5]
    }

    private  readonly sizeToDimentionGreenSound: any = {
        4: "ll_icons_upgrade_green_1", 6: "ll_icons_upgrade_green_2", 9: "ll_icons_upgrade_green_3", 12: "ll_icons_upgrade_green_4", 16: "ll_icons_upgrade_green_5", 20: "ll_icons_upgrade_green_5"
    }
    private  readonly sizeToDimentionRedSound: any = {
        4: "ll_icons_upgrade_red_1", 6: "ll_icons_upgrade_red_2", 9: "ll_icons_upgrade_red_3", 12: "ll_icons_upgrade_red_4", 16: "ll_icons_upgrade_red_5", 20: "ll_icons_upgrade_red_5"
    }
    private readonly  sizeToMeterAlign: any = {
        152: { 4: [-245, 57], 6: [-245, 157], 9: [-180, 157], 12: [-180, 257], 16: [-116, 258], 20: [-116, 355] },
        151: { 4: [-245, 58], 6: [-245, 159], 9: [-180, 159], 12: [-180, 259], 16: [-116, 259], 20: [-116, 355] }
    }
    private  readonly getBlastScale: any = {
        4: 0.5, 6: 0.8, 9: 1, 12: 1, 16: 1, 20: 1
    }
    private readonly  getBlastPos: any = {
        4: [0, 0], 6: [0, 43], 9: [66, 36], 12: [60, 90], 16: [150, 100], 20: [137, 172]
    }
    private readonly  getBlastAnim: any = {
        151: "fish_blast_effect1", 152: "fish_blast_effect2"
    }
    private readonly  collectAnim: string = "_collect_effect"
    private readonly  getCollectAnim: any = {
        151: "", 152: "orc_fish_"
    }
    constructor(view: HoldAndRespinView, model: HoldAndRespinModel) {
        this.view = view;
        this.model = model;
        this.subscribeEvents();
        this.initializeElements();
    }
    private initializeElements() {
        this.bigFishOnReelsContainer = this.view.getContainerByID("BigFishReelsContainer")
    }

    private subscribeEvents(): void {
        this.unSubscribeEvents();
        dispatcher.on(eventDispatchers.SHOW_BIG_FISH, this.showBigFishOnReel, this)
        dispatcher.on(eventDispatchers.COLLECT_BIG_FISH, this.playCollectFishAnimation, this)
    }
    private unSubscribeEvents(): void {
        dispatcher.off(eventDispatchers.SHOW_BIG_FISH, this.showBigFishOnReel, this)
        dispatcher.off(eventDispatchers.COLLECT_BIG_FISH, this.playCollectFishAnimation, this)
    }
    /**
     * shows the big fish on reel
     */
    private showBigFishOnReel(): void {
        const updatedX = "x_" + (ingenuity.parserModel as GameParserModel).getTriggeredBait()
        this.bigFishOnReelsContainer.x = this.bigFishOnReelsContainer.json[updatedX];
        const updatedY = "y_" + (ingenuity.parserModel as GameParserModel).getTriggeredBait()
        this.bigFishOnReelsContainer.y = this.bigFishOnReelsContainer.json[updatedY];

        (ingenuity.parserModel as GameParserModel).getBigFishData().forEach((data: any) => {
            const bigFishCont = this.createBigFishCont(data.size, data.start_col, data.start_row);
            this.playFishBlast(data.size, bigFishCont)
            delayedCall("showbigfish" + data.size + data.start_col + data.start_row, 300, () => {
                killDelayedCall("showbigfish" + data.size + data.start_col + data.start_row);
                this.creatAndPlayBigFish(data.size, bigFishCont);
                this.createMeterOnFish(data.size, bigFishCont);
                this.hideSymbolsOnReel(data.cells);
            }, this);
        })
        delayedCall("bigFishCompleted", 1500, () => {
            killDelayedCall("bigFishCompleted");
            this.removeUnusedBigFish()
            dispatcher.fireEvent(eventDispatchers.SEND_NEXT_SPIN_FLOW);
        }, this);
    }
    /**
     * creates the container and its dynamic allignment
     */
    private createBigFishCont(size: number, reel: number, pos: number): Container {
        const ContainerID = "bigFishContainer" + `_${reel}${pos}_${size}`
        const bigFishContainer: Container = this.view.createContainerClone("bigFishContainer", ContainerID);
        bigFishContainer.x = reel * (this.view.json as any).symWidth;
        bigFishContainer.y = pos * (this.view.json as any).symHeight;
        bigFishContainer.name = ContainerID;
        (bigFishContainer as any).id = ContainerID;
        this.bigFishOnReelsContainer.addChild(bigFishContainer);
        return bigFishContainer;
    }
    //create blast animation before bigfish
    private playFishBlast(size: number, bigFishContainer: Container): void {
        const blastOnFish: SpineBase = this.view.createSpineAnimation("fishBlast");
        bigFishContainer.addChild(blastOnFish);
        blastOnFish.scale.set(this.getBlastScale[size]);
        blastOnFish.x = this.getBlastPos[size][0];
        blastOnFish.y = this.getBlastPos[size][1];
        const animName = this.getBlastAnim[(ingenuity.parserModel as GameParserModel).getTriggeredBait()]
        blastOnFish.playAnim(animName);
    }
    /**
     * to create spine symbol for big fish 
     */
    private creatAndPlayBigFish(size: number, container: Container): void {
        const symbolNumber = (ingenuity.parserModel as GameParserModel).getTriggeredBait()
        if (symbolNumber === 152) {
            this.soundName = this.sizeToDimentionGreenSound[size]
        }
        else {
            this.soundName = this.sizeToDimentionRedSound[size]
        }
        const soundObj: IObject = { id: this.soundName, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
        const bigFish: SpineBase = this.view.createSpineAnimation("bigFishAnim_" + (ingenuity.parserModel as GameParserModel).getTriggeredBait());
        container.addChild(bigFish);
        bigFish.setPause(false);
        const animName = (bigFish.json as any).animName + `${this.sizeToDimention[size][0]}x${this.sizeToDimention[size][1]}`
        bigFish.playAnim(animName, true);
    }
    /**
     * creates meter on the fish
     */
    private createMeterOnFish(size: number, bigFishCont: Container): void {
        const meter = this.view.createMeterClone("fishMeter_" + (ingenuity.parserModel as GameParserModel).getTriggeredBait());
        bigFishCont.addChild(meter);
        meter.x = this.sizeToMeterAlign[(ingenuity.parserModel as GameParserModel).getTriggeredBait()][size][0];
        meter.y = this.sizeToMeterAlign[(ingenuity.parserModel as GameParserModel).getTriggeredBait()][size][1];
        meter.setCurrencyFormattedValue((ingenuity.parserModel as GameParserModel).getHoldNRespinBoxMultipliers()[size]);
    }
    /**
     * used to hide symbol behind big fishes
     */
    private hideSymbolsOnReel(cell: number[][]): void {
        cell.forEach((offset: number[]) => {
            const reel = this.model.convertOffsetToPos(offset[0], offset[1])
            dispatcher.fireEvent(eventDispatchers.HIDE_REEL_BEHIND_FISH, reel);
        })
    }
    /**
     * to play win animation on fish
     */
    private playCollectFishAnimation(): void {
        this.bigFishOnReelsContainer.children.forEach((container: Container) => {
            const spineAnim = container.children[1]
            if (spineAnim.json.type === "spine") {
                const match = container.json.id.match(/_(\d+)$/); // Match digits after the last underscore
                let size: number;
                if (match) {
                    size = parseInt(match[1], 10);
                }
                const animName = `${this.getCollectAnim[(ingenuity.parserModel as GameParserModel).getTriggeredBait()]}${this.sizeToDimention[size][0]}x${this.sizeToDimention[size][1]}${this.collectAnim}`
                spineAnim.playAnim(animName, false)
                spineAnim.onComplete.addOnce(() => {
                    const animName = (spineAnim.json as any).animName + `${this.sizeToDimention[size][0]}x${this.sizeToDimention[size][1]}`
                    spineAnim.playAnim(animName, true);

                })
            }
        })
    }
    /**remove extra big fish from reel , which were present  */
    private removeUnusedBigFish(): void {
        (ingenuity.parserModel as GameParserModel).getRemovedBigFish()?.forEach((data: any) => {
            const name = "bigFishContainer" + `_${data.start_col}${data.start_row}_${data.size}`
            const container = this.view.getContainerByID(name)
            if (container) {
                container.forEach((child: any) => {
                    if (child.json.type === "spine") {
                        child.setPause(true);
                        child.destroy();
                    }
                })
                container?.removeChildren();
                container?.destroy();
            }
        })
    }
    /**
     * reset the fishes and container
     */
    private resetBigFishes(): void {
        this.bigFishOnReelsContainer.children.forEach((child: any) => {
            child.children.forEach((innerChild: any) => {
                if (innerChild.json.type === "spine") {
                    innerChild.setPause(true);
                    innerChild.destroy();
                }
            });
        });
        this.bigFishOnReelsContainer.removeChildren();
        this.bigFishOnReelsContainer.children = [];
    }
    /**
     * reset feature and controller
     */
    public resetController(): void {
        this.resetBigFishes();
        this.unSubscribeEvents()
    }
}